exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".item[data-v-465b0748]{padding:18px 0;border-bottom:1px dashed #dfe6ec}.item[data-v-465b0748]:last-child{border-bottom:none}.iconfont[data-v-465b0748]{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-465b0748","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./vue/views/dashboard/notice.vue
// module id = 450
// module chunks = 0